angular.module('aprima-core-ui').directive('apMessageStatus', [function () {
    'use strict';

    return {
        scope: {
            message: '='
        },
        templateUrl: '/core-ui/views/directives/apMessageStatus.html',
        link: function () {

        }
    };

}]);